import React from 'react';

export const SearchIcon = ({ className = '', strokeWidth = '' }) => (
  <svg
    className={className}
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.0703 13.5L9.07031 9.5L13.0703 13.5ZM10.4036 6.16667C10.4036 6.7795 10.2829 7.38634 10.0484 7.95252C9.8139 8.51871 9.47015 9.03316 9.03681 9.4665C8.60347 9.89984 8.08902 10.2436 7.52284 10.4781C6.95665 10.7126 6.34981 10.8333 5.73698 10.8333C5.12414 10.8333 4.51731 10.7126 3.95112 10.4781C3.38494 10.2436 2.87049 9.89984 2.43715 9.4665C2.00381 9.03316 1.66006 8.51871 1.42554 7.95252C1.19102 7.38634 1.07031 6.7795 1.07031 6.16667C1.07031 4.92899 1.56198 3.742 2.43715 2.86683C3.31232 1.99167 4.4993 1.5 5.73698 1.5C6.97466 1.5 8.16164 1.99167 9.03681 2.86683C9.91198 3.742 10.4036 4.92899 10.4036 6.16667Z"
      stroke="currentColor"
      strokeWidth={strokeWidth === '' ? '1.33' : ''}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
